/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordResetEndpointRequest
 */
export interface PasswordResetEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetEndpointRequest
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetEndpointRequest
     */
    password: string;
}

export function PasswordResetEndpointRequestFromJSON(json: any): PasswordResetEndpointRequest {
    return PasswordResetEndpointRequestFromJSONTyped(json, false);
}

export function PasswordResetEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'password': json['password'],
    };
}

export function PasswordResetEndpointRequestToJSON(value?: PasswordResetEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'password': value.password,
    };
}


